export class ObjectCompare {
  static isEqual(obj1: unknown, obj2: unknown): boolean {
    const normalise = (val: unknown): unknown => {
      if (Array.isArray(val)) {
        return val.map(normalise);
      } else if (val !== null && typeof val === "object") {
        return Object.keys(val)
          .sort()
          .reduce<Record<string, unknown>>((acc, key) => {
            const value = (val as Record<string, unknown>)[key];
            acc[key] = normalise(typeof value === "string" ? value.trim() : value);
            return acc;
          }, {});
      } else {
        return val;
      }
    };

    return JSON.stringify(normalise(obj1)) === JSON.stringify(normalise(obj2));
  }

  static isEqualArray = (array1: string[], array2: string[]) =>
    array1.length === array2.length && array1.every((item) => array2.includes(item));
}
